import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-news',
  standalone: true,
  templateUrl: './news.html',
  imports: [],
  styleUrl: './news.scss'
})
export class News {
  @Input() title?: string;
  @Input() date?: string;
  @Input() time?: string;
}
